import { ErrorOperation, NamingConvention, StringOperation } from "namirasoft-core";
import { PolicyRow } from "./row/PolicyRow";

export class AccessControl
{
    static splitResources(ids: string[] | string): string[]
    {
        if (typeof (ids) === "string")
            return StringOperation.split(ids).map(e => AccessControl.formatResource(e));
        return ids.map(e => AccessControl.formatResource(e));
    }
    static splitEntities(enitties: string[] | string): string[]
    {
        if (typeof (enitties) === "string")
            return StringOperation.split(enitties).map(e => AccessControl.formatEntity(e));
        return enitties.map(e => AccessControl.formatEntity(e));
    }
    static splitActions(actions: string[] | string): string[]
    {
        if (typeof (actions) === "string")
            return StringOperation.split(actions).map(e => AccessControl.formatAction(e));
        return actions.map(e => AccessControl.formatAction(e));
    }
    static formatResource(resource: string): string
    {
        return NamingConvention.auto.convert(resource, NamingConvention.lower_case_dash).trim();
    }
    static formatEntity(entity: string): string
    {
        return NamingConvention.auto.convert(entity, NamingConvention.Pascal_Case).trim();
    }
    static formatAction(action: | string): string
    {
        return NamingConvention.auto.convert(action, NamingConvention.Pascal_Case).trim();
    }
    static isApplicationAction(action: string): boolean
    {
        return action.startsWith("_");
    }
    static isValidProductID(policy_product_id: string, product_id: string): boolean
    {
        return (policy_product_id == "*" || policy_product_id === product_id)
    }
    static isValidEntity(policy_entity: string[] | string, entity: string): boolean
    {
        return policy_entity == "*" || AccessControl.splitEntities(policy_entity).includes(entity);
    }
    static isValidAction(policy_actions: string[] | string, action: string): boolean
    {
        return (policy_actions == "*" && !AccessControl.isApplicationAction(action)) || AccessControl.splitActions(policy_actions).includes(action);
    }
    static isValidResource(policy_resources: string[] | string, id: string | null): boolean
    {
        return policy_resources == "*" || id === null || AccessControl.splitResources(policy_resources).includes(id);
    }
    static isValid(policies: PolicyRow[], product_id: string, entity: string, action: string, id: string | null): boolean
    {
        entity = AccessControl.formatEntity(entity);
        action = AccessControl.formatAction(action);
        for (let i = 0; i < policies.length; i++)
        {
            const policy = policies[i];
            if (AccessControl.isValidProductID(policy.product_id, product_id))
                if (AccessControl.isValidEntity(policy.entity, entity))
                    if (AccessControl.isValidAction(policy.actions, action))
                        if (AccessControl.isValidResource(policy.resources, id))
                            return policy.allow;
        }
        return false;
    }
    static check(policies: PolicyRow[], product_id: string, entity: string, action: string, id: string | null): void
    {
        if (!AccessControl.isValid(policies, product_id, entity, action, id))
        {
            console.log({
                policies, product_id, entity, action, id
            })
            let message = `Access denied (Entity: '${entity}', Action: '${action}')`;
            if (id)
                message += ` on resource: ${id}`;
            throw ErrorOperation.getHTTP(403, message);
        }
    }
}